export default function loadImage(url) {
  return new Promise(function (resolve, reject) {

    var image = new Image();

    image.onload = resolve;

    image.onerror = function () {
      return reject(new Error('Error when loading ' + url));
    };

    image.src = url;
  });
}